// extracted by mini-css-extract-plugin
export default {"loadingWrapper":"Loading_loadingWrapper__0BPgm","loading":"Loading_loading__06KqV"};